import React, { useState } from "react";
import SkeyepredictProjectsTable from "./SkeyepredictProjectsTable";
import SkeyepredictAddProjectDialog from "./SkeyepredictAddProjectDialog";
import { fetchUsers, createProject } from "./SkeyepredictProjectsAPI";
import PageLayout from "../../../components/PageLayout";
import SearchToolbar from "../../../components/SearchToolbar";
import usePageTitle from "../../../services/usePageTitle";
import usePageState from "../../../hooks/usePageState";
import useIsRoleUser from "../../../hooks/useIsRoleUser";
import skeyepredictProjectsHelp from "../../../content/help/skeyepredict-projects.json";

export default function SkeyepredictProjects({
  pageTitle = "SkeyePredict Projects",
}) {
  usePageTitle("SkeyePredict Projects - SkeyeGate™");
  const isRoleUser = useIsRoleUser();

  const {
    filteredData,
    loading,
    searchText,
    page,
    pageSize,
    messageApi,
    contextHolder,
    handleSearch,
    clearFilter,
    loadData,
    onPageChange,
  } = usePageState({
    fetchFn: async () => {
      const users = await fetchUsers();
      if (!Array.isArray(users)) return [];
      return users.flatMap((user) =>
        (user.projects || []).map((project) => ({
          ...project,
          username: user.username,
        })),
      );
    },
    filterFields: [(p) => p.id?.toString(), "username", "projectPath"],
  });

  const [addModalOpen, setAddModalOpen] = useState(false);

  const handleAddProject = async (values) => {
    try {
      await createProject(values);
      messageApi.success("Project created successfully");
      loadData();
    } catch (error) {
      console.error("Create project error:", error);
      throw error;
    }
  };

  return (
    <PageLayout
      title={pageTitle}
      logo="/img/majesteye-icon-skeye-predict-square-white-background-no-label"
      description="Manage your SkeyePredict projects. Upload datasets (.dat) and view all your projects."
      helpContent={skeyepredictProjectsHelp}
    >
      {contextHolder}
      <SearchToolbar
        search={searchText}
        onSearchChange={handleSearch}
        onClearFilter={clearFilter}
        onAdd={() => setAddModalOpen(true)}
        showAdd={!isRoleUser}
      />
      <SkeyepredictProjectsTable
        data={filteredData}
        loading={loading}
        page={page}
        pageSize={pageSize}
        onPageChange={onPageChange}
        isRoleUser={isRoleUser}
      />
      <SkeyepredictAddProjectDialog
        open={addModalOpen}
        onClose={() => setAddModalOpen(false)}
        onSave={handleAddProject}
      />
    </PageLayout>
  );
}
